'use strict';

/**
 * Initialize smooth scroll links
 */
import SmoothScroll from '../components/SmoothScroll';

new SmoothScroll(document.documentElement, {
    offset: 68,
    medias: [
        {
            media: 'screen and (max-width: 56.25em)',
            settings: {
                offset: 55,
            },
        },
    ],
});
